// deps
import React, { memo, useEffect } from "react";

// styles
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { AddCakeMessagePillContainer, CakeText, IconStyled } from "./AddCakeMessagePill.styled";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { ADD_CAKE_MESSAGE_PILL_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { ADD_CAKE_MESSAGE_PILL_TEXT, ADD_CAKE_MESSAGE_STATIC_ASSETS } from "./constants";
import { isEmpty } from "@swiggy-private/js-utils";

export interface CartAddCakeMessageProps {
    onClick: VoidFunction;
    text: string;
    hideAnimation: boolean;
    isEditState: boolean;
    onImpression: () => void;
    pmmBannerRef: React.RefObject<HTMLButtonElement>;
}

const AddCakeMessagePill = ({
    onClick,
    text,
    hideAnimation,
    isEditState,
    onImpression,
    pmmBannerRef,
}: CartAddCakeMessageProps) => {
    useEffect(() => {
        if (!isEmpty(text)) {
            onImpression();
        }
    }, [onImpression, text]);

    return (
        <AddCakeMessagePillContainer
            onClick={onClick}
            hideAnimation={hideAnimation}
            data-testid={ADD_CAKE_MESSAGE_PILL_TEST_IDS.PILL_CONTAINER}
            isEditState={isEditState}
            type="button"
            ref={pmmBannerRef}
        >
            <IconStyled as="span">
                <Image cloudinaryId={ADD_CAKE_MESSAGE_STATIC_ASSETS.CAKE_ICON} />
            </IconStyled>
            <CakeText>
                <Text
                    color="text_Med_Emphasis"
                    variant="V2.body3.neutral.medium"
                    data-testid={ADD_CAKE_MESSAGE_PILL_TEST_IDS.PILL_TEXT}
                >
                    {text || ADD_CAKE_MESSAGE_PILL_TEXT}
                </Text>
            </CakeText>
        </AddCakeMessagePillContainer>
    );
};

export default memo(AddCakeMessagePill);
